import axios from 'axios';
import Cookies from 'js-cookie';
import { getAuthHeader } from './userInfo-actions';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
);

export const endedCourses = async () => {
  let userCourses = await axios.get(
    `${process.env.REACT_APP_API_PATH_COURSE}/course/enrolled/courses`,
    {
      params: {},
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (userCourses.data.endedCourses) {
    return userCourses.data.endedCourses;
  }
  return false;
};
